import { multiOffersService } from '../../infrastructure/Factory'

export default {
  updateAllDestinations(state, allDestinations) {
    state.allDestinations = allDestinations
  },
  updateOffer(state, offer) {
    state.offer = offer
  },
  updateSelectedCode(state, code) {
    state.selectedCode = code
  },
  prices(state, prices) {
    state.prices = prices
  },
  hotels(state, hotels) {
    state.hotels = hotels
  },
  updateFilterApply(state, filter) {
    const countries = filter.type === 'country' ? filter.code : ''
    const cities = filter.type === 'city' ? filter.code : ''

    const params = {
      countryCode: countries,
      cityCode: cities,
      checkInDate: state.datesFromLanding.startDate,
      checkOutDate: state.datesFromLanding.endDate
    }

    const urlPrefix = multiOffersService.multiOffersRedirect(params)

    history.replaceState({}, null, window.location.origin + window.location.pathname + urlPrefix)

    state.filterApply = filter
    window.dispatchEvent(new CustomEvent('urlParamsUpdated'))
  },
  updatedatesFromLanding(state, dates) {
    state.datesFromLanding = dates
  },
  setFormattedLocation(state, locations) {
    state.formattedLocation = locations
  },
  setMoreDestinationsBanners(state, banners) {
    state.moreDestinationsBanners = banners
  },
  setModalSmartLinkImages(state, images) {
    state.modalSmartLinkImages = images
  }
}
